const productsFiles = [
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220002",
        id: "1",
        title: "HY2400",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/InstallationAndRequirements1.pdf",
        isHasInstallationAndRequirements: "true",
        installationAndRequirementsUrl: "../assets/pdf/UseAndMaintenance1.pdf",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy.pdf",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220003",
        id: "2",
        title: "HY3000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance2.pdf",
        isHasInstallationAndRequirements: "true",
        installationAndRequirementsUrl: "../assets/pdf/InstallationAndRequirements2.pdf",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy.pdf",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220004",
        id: "3",
        title: "HY4000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance3.pdf",
        isHasInstallationAndRequirements: "true",
        installationAndRequirementsUrl: "../assets/pdf/InstallationAndRequirements3.pdf",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy.pdf",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220005",
        id: "4",
        title: "HY5000-6000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance4.pdf",
        isHasInstallationAndRequirements: "true",
        installationAndRequirementsUrl: "../assets/pdf/InstallationAndRequirements4.pdf",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy.pdf",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220006",
        id: "5",
        title: "HY8000-10000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance5.pdf",
        isHasInstallationAndRequirements: "true",
        installationAndRequirementsUrl: "../assets/pdf/InstallationAndRequirements5.pdf",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy.pdf",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220007",
        id: "6",
        title: "HY13000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance6.pdf",
        isHasInstallationAndRequirements: "true",
        installationAndRequirementsUrl: "../assets/pdf/InstallationAndRequirements6.pdf",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy.pdf",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220008",
        id: "7",
        title: "HY15000-28000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance7.pdf",
        isHasInstallationAndRequirements: "true",
        installationAndRequirementsUrl: "../assets/pdf/InstallationAndRequirements7.pdf",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy.pdf",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220009",
        id: "8",
        title: "HY34000-45000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance8.pdf",
        isHasInstallationAndRequirements: "true",
        installationAndRequirementsUrl: "../assets/pdf/InstallationAndRequirements8.pdf",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy.pdf",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220010",
        id: "9",
        title: "HYTC 600",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/OperationMaintenanceHYTC600.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy2.pdf",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220011",
        id: "10",
        title: "SM Series",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/SMSeriesOperationAndMaintenanceManual.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy2.pdf",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220012",
        id: "11",
        title: "SM100 Series",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/SM100SeriesOperationAndMaintenanceManual.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy2.pdf",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220013",
        id: "12",
        title: "SME Series",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/SMESeriesOperationAndMaintenanceManual.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy2.pdf",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220014",
        id: "13",
        title: "TM Series",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/TMSeriesOperationAndMaintenanceManual.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "true",
        warrantyPolicyUrl: "../assets/pdf/HavayarWarrantyPolicy2.pdf",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220014",
        id: "14",
        title: "اسکرو 2400",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance2400.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "false",
        warrantyPolicyUrl: "",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220014",
        id: "15",
        title: "اسکرو 3000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance3000.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "false",
        warrantyPolicyUrl: "",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220014",
        id: "16",
        title: "اسکرو 4000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance4000.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "false",
        warrantyPolicyUrl: "",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220014",
        id: "17",
        title: "اسکرو 5000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance5000.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "false",
        warrantyPolicyUrl: "",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220014",
        id: "18",
        title: "اسکرو 6000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance6000.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "false",
        warrantyPolicyUrl: "",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220014",
        id: "19",
        title: "اسکرو 8000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance8000.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "false",
        warrantyPolicyUrl: "",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220014",
        id: "20",
        title: "اسکرو 10000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance10000.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "false",
        warrantyPolicyUrl: "",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220014",
        id: "21",
        title: "اسکرو 13000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance13000.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "false",
        warrantyPolicyUrl: "",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220014",
        id: "22",
        title: "اسکرو 15000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance15000.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "false",
        warrantyPolicyUrl: "",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220014",
        id: "23",
        title: "اسکرو 19000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance19000.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "false",
        warrantyPolicyUrl: "",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220014",
        id: "24",
        title: "اسکرو 23000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance23000.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "false",
        warrantyPolicyUrl: "",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220014",
        id: "25",
        title: "اسکرو 28000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance28000.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "false",
        warrantyPolicyUrl: "",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220014",
        id: "26",
        title: "اسکرو 34000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance34000.pdf",
        isHasInstallationAndRequirements: "false",
        isHasWarrantyPolicy: "false",
        warrantyPolicyUrl: "",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220014",
        id: "27",
        title: "اسکرو 45000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance45000.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "false",
        warrantyPolicyUrl: "",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220014",
        id: "28",
        title: "اسکرو 50000",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/UseAndMaintenance50000.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "false",
        warrantyPolicyUrl: "",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220014",
        id: "29",
        title: "اسکرو روغنی آب خنک",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/WaterCoolScrewCompressor.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "false",
        warrantyPolicyUrl: "",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220014",
        id: "30",
        title: "Airmaster, Q Series",
        isHasUseAndMaintenance: "true",
        useAndMaintenanceUrl: "../assets/pdf/AirmasterQSeries.pdf",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "false",
        warrantyPolicyUrl: "",
        isNotCompressorFile: "false"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220014",
        id: "31",
        title: "دفترچه راهنمای کاربری HY-MASTER C1",
        isHasUseAndMaintenance: "false",
        useAndMaintenanceUrl: "",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "false",
        warrantyPolicyUrl: "",
        isNotCompressorFile: "true",
        specialFileUrl:"../assets/pdf/HY-MASTER-C1.pdf"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220014",
        id: "32",
        title: "فرم اعلام الزامات گارانتی و شرایط استاندارد نصب و راه اندازی",
        isHasUseAndMaintenance: "false",
        useAndMaintenanceUrl: "",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "false",
        warrantyPolicyUrl: "",
        isNotCompressorFile: "true",
        specialFileUrl:"../assets/pdf/InstallationAndRequirements.pdf"
    },
    {
        key: "bed83bb2-8a8e-12ed-a5eb-0232ac220014",
        id: "33",
        title: "نظامنامه گارانتی هوایار",
        isHasUseAndMaintenance: "false",
        useAndMaintenanceUrl: "",
        isHasInstallationAndRequirements: "false",
        installationAndRequirementsUrl: "",
        isHasWarrantyPolicy: "false",
        warrantyPolicyUrl: "",
        isNotCompressorFile: "true",
        specialFileUrl:"../assets/pdf/HavayarWarrantyPolicyFile.pdf"
    }
];

export function getProductFilesById(id) {
    return productsFiles.filter(m => m.id === id);
}